import { render, staticRenderFns } from "./IngredientGroupDisplay.vue?vue&type=template&id=da0165b0&scoped=true&"
import script from "./IngredientGroupDisplay.vue?vue&type=script&lang=js&"
export * from "./IngredientGroupDisplay.vue?vue&type=script&lang=js&"
import style0 from "./IngredientGroupDisplay.vue?vue&type=style&index=0&id=da0165b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0165b0",
  null
  
)

export default component.exports